<template>
  <div>
    <canvas :id="canvaId"></canvas>
    <LoadingCover spinner="dotsbar" v-show="loading" />
  </div>
</template>
<script>
  import { uuid } from "vue-uuid";
  import { 
    Chart, 
    registerables 
  } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import CONSTANTS from "@/constants";
  import { formatter } from "@/general";
  import { dataCostoVentasDocumentos } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  Chart.register(...registerables)

  export default {
    name: 'SalesParticipationChart',
    data() {
      return {
        uuid,
        formatter,
        loading: false,
        canvaId: "",
        colorsLabels: [
          CONSTANTS.colors.color01,
          CONSTANTS.colors.color02,
          CONSTANTS.colors.color03,
          CONSTANTS.colors.color04,
          CONSTANTS.colors.color05,
          CONSTANTS.colors.color06,
          CONSTANTS.colors.color07,
          CONSTANTS.colors.color08,
          CONSTANTS.colors.color09,
          CONSTANTS.colors.color10
        ],
        dataSalesParticipation: null
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      typeReport: String,
      idEmployeeGroup: String,
      idEmployee: String,
      minPercentage: Number,
      valuesDivisor: Number
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataSalesAndCosts() {
        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Tipo_Reporte": this.typeReport,
            "Tipo_Utilidad": "venta",
            "Id_GrupoPersonal": this.idEmployeeGroup,
            "Id_Personal": this.idEmployee
          }
          const { response } = await dataCostoVentasDocumentos(this, parameters);
          this.dataSalesParticipation = response
        } catch (error) {
          console.log(error)          
        }
      },
      setupChart() {
        let optionsChart = {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: this.title
            },
            legend: {
                display: true,
                position: "left",
                labels: {
                  boxWidth: 5,
                  boxHeight: 5,
                  font: {
                    size: 10
                  }
                }
            },
            tooltip: {
              enabled: true,
              usePointStyle: true,
              padding: 12,
              borderwidth: 1,
              backgroundColor: 'midnightblue',
              callbacks: {
                label : function (context) {
                  return [context.label, "$" + context.formattedValue];
                }
              }
            },
            datalabels: {
              font: {
                size: 10
              },
              formatter: (value) => {
                let sum = 0
                this.dataSalesParticipation.map(data => sum += (data.Valor_Mercancia / this.valuesDivisor))
                let percentage = ((value * 100) / sum).toFixed(2)
                if (percentage < this.minPercentage) return ""

                return `${percentage}%`
              }
            }
          }
        }

        const chart = new Chart(document.getElementById(this.canvaId), {
          type: "doughnut",
          data: {
            labels: this.dataSalesParticipation.map(data => data.Descripcion ? data.Descripcion : "N/D"),
            datasets: [
              {
                data: this.dataSalesParticipation.map(data => (data.Valor_Mercancia / this.valuesDivisor)),
                backgroundColor: this.colorsLabels.map(data => data)
              }
            ]
          },
          options: optionsChart,
          plugins: [ChartDataLabels]
        });

        chart.update();
      }
    },
    async mounted() {
      this.loading = true

      try {
        this.canvaId = uuid.v1();

        await this.getDataSalesAndCosts();
        this.setupChart();
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false;
      }
    }
  }
</script>
